/**
 * Reusable empty state component for sections with no data
 */

// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon, IconName} from '@wandb/weave/components/Icon';
import React from 'react';

interface EmptyStateProps {
  icon: IconName;
  message: string;
  iconColor?: string;
  iconBgGradient?: string;
  subtitle?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  message,
  iconColor = 'text-moon-400',
  iconBgGradient = 'from-moon-50 to-moon-100',
  subtitle,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-moon-250 bg-gradient-to-b from-moon-50 to-white py-36 h-full `}>
      <div
        className={`flex h-64 w-64 items-center justify-center rounded-full bg-gradient-to-br ${iconBgGradient}`}>
        <Icon name={icon} className={iconColor} width={28} height={28} />
      </div>
      <div className="text-center">
        <p className="text-sm font-medium text-moon-800">{message}</p>
        {subtitle && <p className="mt-4 text-xs text-moon-500">{subtitle}</p>}
      </div>
    </div>
  );
};
